import React from 'react';
import { useTranslation } from 'react-i18next';
import { AppButton, Box, Inscription } from '@common-fe/common-fe';

import { useMyMoneyStore } from '@/modules/UseMyMoney/stores';
import { UseMyMoneyOption } from '@/modules/UseMyMoney/UseMyMoney.types';

interface Props {
  onUploadFile?: () => void;
}

const EmptyDocumentCard: React.FC<Props> = ({ onUploadFile }) => {
  const { t } = useTranslation();
  const { useMyMoneyOption } = useMyMoneyStore();

  return (
    <Box
      data-testid="document-upload-card-empty"
      width="100%"
      style={{ maxWidth: '343px' }}
      pad="spacing12"
      direction="column"
      justify="center"
      align="start"
      gap="spacing8"
      round="container1Round"
      border={{ color: 'border2', size: '1px' }}
      background="canvas"
      flex={false}
    >
      <Box direction="row" width="100%" align="center" justify="between">
        <Inscription
          data-testid="document-upload-card_title"
          weight="bold"
          color="textBody"
          lineHeight="20px"
        >
          {t('No documents')}
        </Inscription>

        <AppButton
          testId="document-upload-card_upload-btn"
          buttonType="secondary"
          onClick={onUploadFile}
          size="M"
          style={{ width: '100px', height: '40px' }}
        >
          {t('Upload')}
        </AppButton>
      </Box>

      <Inscription data-testid="document-upload-card_description" color="textSecondary" lineHeight="20px">
        {useMyMoneyOption === UseMyMoneyOption.HSA_WITHDRAWAL
          ? t("Upload receipts for your HSA withdrawal. Not required, but useful to keep for tax records.")
          : t("Add a document and we'll try to fill the details for you.")}
      </Inscription>
    </Box>
  );
};

export default EmptyDocumentCard;
